import React, { PropsWithChildren } from 'react';

import { Props } from '@/ui/components/Container/types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const Container = ({ children, type = 'default' }: PropsWithChildren<Props>) => {
  let className = '';

  if (type === 'default') {
    className = 'mb-2';
  }

  if (type === 'page') {
    className = ' bg-gray-100 mb-4 p-2 mx-auto max-w-7xl sm:px-4 lg:px-6';
  }

  if (type === 'full-width-page') {
    className = 'bg-gray-100 mb-4 p-2 mx-auto w-full sm:px-4 lg:px-6';
  }

  return <div className={className}>{children}</div>;
};

export default Container;
